<form [formGroup]="frmGrp" class="row" [style.visibility]="visFunc(wizGrp) ? 'visible' : 'hidden'">
  <div istag="label" class="content label" id="labeltxt">
    {{ label }}
  </div>

  <input istag="input" class="content input" [formControlName]="name" />
</form>
